<template>
    <div class="p-5 darker">

        <div class="row mt-5">
            <div class="col-md-8 border-bottom-medium mb-4">
                <div class="darker font-weight-600">Payment Method</div>
                <div class="darker fs-small">Select the payments methods you would like to accept.</div>
            </div>


            <div class="col-md-8 mb-4">
                <div class="row">
                    <div class="col-md-6 d-flex flex-row align-items-center justify-content-between">
                        <div class="row w-100">
                            <div class="col-sm-10">
                                <div>Cash</div>
                            </div>
                            <div class="col-sm-2">
                                <toggle-button :value="true" v-model="paymentmethod.cash" :sync="true" :labels="{checked: 'YES', unchecked: 'NO'}"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-8 mb-4">
                <div class="row">
                    <div class="col-md-6 d-flex flex-row align-items-center justify-content-between">
                        <div class="row w-100">
                            <div class="col-sm-10">
                                <div>Creadit Card</div>
                            </div>
                            <div class="col-sm-2">
                                <toggle-button :value="true" v-model="paymentmethod.creditCard" :sync="true" :labels="{checked: 'YES', unchecked: 'NO'}"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-8 mb-1">
                <div class="row">
                    <div class="col-md-6 d-flex flex-row align-items-center justify-content-between">
                        <div class="row w-100">
                            <div class="col-sm-10">
                                <div>PayPal</div>
                            </div>
                            <div class="col-sm-2">
                                <toggle-button :value="true" v-model="paymentmethod.paypal" :sync="true" :labels="{checked: 'YES', unchecked: 'NO'}"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-8 mb-4">
                <div class="row">
                    <div class="col-md-6">
                        <label class="full">
                            PayPal API - KEY
                            <input type="text" class="bg-lighter" v-model="paymentmethod.paypalApiKey" :disabled="!paymentmethod.paypal">
                        </label>
                    </div>
                </div>
            </div>

            <div class="col-md-8 mb-1">
                <div class="row">
                    <div class="col-md-6 d-flex flex-row align-items-center justify-content-between">
                        <div class="row w-100">
                            <div class="col-sm-10">
                                <div>Multibanco</div>
                            </div>
                            <div class="col-sm-2">
                                <toggle-button :value="true" v-model="paymentmethod.multibanco" :sync="true" :labels="{checked: 'YES', unchecked: 'NO'}"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-8 mb-4">
                <div class="row">
                    <div class="col-md-6">
                        <label class="full">
                            Multibanco API - KEY
                            <input type="text" class="bg-lighter" v-model="paymentmethod.multibancoApiKey" :disabled="!paymentmethod.multibanco">
                        </label>
                    </div>
                </div>
            </div>

        </div>

        <div class="col-md-12 text-right">
            <input type="submit" value="Save" class="btn widest ml-auto" @click="save">
        </div>

    </div>
</template>

<script>
    import extendedVSelect from '@/extends/vue-select'
    import {mapGetters, mapActions} from 'vuex'

    export default {
        data: function() {
            return {
            }
        },
        methods:{
            save: function(){
                this.$emit('save');
            }
        },
        props:['paymentmethod'],
        components:{
            vSelect: extendedVSelect
        }
    }
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// TabPaymentMehtod.vue?6bda30b8